import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases } from 'vuetify/iconsets/mdi-svg';
import { faAliases } from './fontAwesomeIcons';
import { mdiAliases } from './materialIcons';
import type { BaseIconProps } from '@/components/ui/BaseIcon.vue';
import { mapComponentFromConfig } from './vuetifyIconConfig';
import { mainTheme, darkTheme } from './theme';

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: mainTheme,
      dark: darkTheme
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...mdiAliases,
      ...faAliases
    },
    sets: {
      mdi: {
        component: (props) => mapComponentFromConfig(props as BaseIconProps, mdiAliases)
      },
      fa: {
        component: (props) => mapComponentFromConfig(props as BaseIconProps, faAliases)
      }
    }
  }
});
